import { NavItem } from "./types";

// // // //

/**
 * isNavItemActive
 * Checks if a NavItem (or its nested NavItems) has a matching href.
 * @param {NavItem} item - The NavItem to check for active state.
 * @param {string} pathname - The pathname to compare with NavItem href.
 * @returns {boolean} - True if a matching NavItem is found, otherwise false.
 */
export function isNavItemActive(props: {
    item: NavItem;
    pathname: string;
}): boolean {
    const { item, pathname } = props;
    const { activeRoutes = [] } = item;

    if (item.href === pathname) {
        return true;
    }

    if (activeRoutes.includes(pathname)) {
        return true;
    }

    return false;
}

/**
 * areNavItemsActive
 * Checks if a NavItem (or its nested NavItems) has a matching href.
 * @param {NavItem} item - The NavItem to check for active state.
 * @param {string} pathname - The pathname to compare with NavItem href.
 * @returns {boolean} - True if a matching NavItem is found, otherwise false.
 */
export function areNavItemsActive(props: {
    items: NavItem[];
    pathname: string;
}): boolean {
    const { items, pathname } = props;

    // Check nested items recursively
    for (const nestedItem of items) {
        if (isNavItemActive({ item: nestedItem, pathname })) {
            return true;
        }
    }

    return false;
}
